module.exports = __webpack_public_path__ + "static/media/signup-illustration.207d7475.png";